import i18n from "i18next";
import { reactI18nextModule } from "react-i18next";

import translationEN from "./locales/english/translation.json";
import translationAR from "./locales/arabic/translation.js";
import translationTG from "./locales/tagalog/translation.json";

// the translations
let updatedARTranslation = { ...translationAR, FAQs: "الاسئلة المتكررة" };
const resources = {
  english: {
    translation: translationEN,
  },
  arabic: {
    translation: updatedARTranslation,
  },
  tagalog: {
    translation: translationTG,
  },
};

i18n
  .use(reactI18nextModule) // passes i18n down to react-i18next
  .init({
    resources,
    lng: localStorage.getItem("language")
      ? localStorage.getItem("language")
      : "english",

    keySeparator: false, // we do not use keys in form messages.welcome
    nsSeparator: "|",
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
